import React from 'react';
import ReactDOM from 'react-dom/client';




const shoot = () => {
   alert("Great Shot!");
}

console.log('Error: Print your error')
console.error('Error: Print your error')


const MissedGoal = () => {
   return <h1>MISSED!</h1>;
}


const learning_29_05_2025 = () => (
   <div>

      learning_29_05_2025 Component
      <br />

      <button onClick={shoot}>Take the shot!</button>

      <div>

         <h1>MISSED!</h1>;
      </div>
      <h1>Who lives in my garage?</h1>
     <br/>


      <label><h4>Enter your name:</h4>
         <input type="text" />
      </label>

   </div>
);


learning_29_05_2025.propTypes = {};

learning_29_05_2025.defaultProps = {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<learning_29_05_2025 />);





export default learning_29_05_2025;
